"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const checkboxWidget_1 = __importDefault(require("./checkboxWidget"));
const checkboxesWidget_1 = __importDefault(require("./checkboxesWidget"));
const dateWidget_1 = __importDefault(require("./dateWidget"));
const draftReaderWidget_1 = __importDefault(require("./draftReaderWidget"));
const numericWidget_1 = __importDefault(require("./numericWidget"));
const radio_1 = __importDefault(require("./radio"));
const textWidget_1 = __importDefault(require("./textWidget"));
const groupWidget_1 = __importDefault(require("./groupWidget"));
const widgets = {
    TextWidget: textWidget_1.default,
    NumericWidget: numericWidget_1.default,
    CheckboxWidget: checkboxWidget_1.default,
    CheckboxesWidget: checkboxesWidget_1.default,
    draft: draftReaderWidget_1.default,
    TextareaWidget: textWidget_1.default,
    SelectWidget: textWidget_1.default,
    RadioWidget: radio_1.default,
    'alt-date': dateWidget_1.default,
    'workflow-group': groupWidget_1.default
};
exports.default = widgets;
//# sourceMappingURL=index.js.map